import React from "react";
import PrimaryNav from "../../components/PrimaryNav/PrimaryNav";
import { useMediaQuery } from 'react-responsive';
import "./Homepage.css"
import { APITAGS } from "../../helpers/enums/apiTags";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { handleLogin } from "../../helpers/authUtil";

const Homepage = () => {
  const mediumScreens = useMediaQuery({ maxWidth: 720});
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  

  const handleOnClick = (link, privacy) => {
    let redirectPath = window.location.origin + link
    if (privacy === APITAGS.INTERNAL) {
      if (isAuthenticated) {
        window.location.href = redirectPath
      } else {
        sessionStorage.setItem('postLoginUrl', link)
        handleLogin(instance);
      }
    } else {
      window.location.href = redirectPath
    }
  }

  return(
    <>
      <PrimaryNav />
      <main>
        {/* Hero Section */}
        <div className={`flex container ${mediumScreens ? 'col sa ai-center' : 'sa l-gap'}`}>
          <div className="sm-pad">
            <h1 className='patua-one-regular'>
              Welcome to the CDC Digital Gateway!
            </h1>
            <p className='patua-one-regular fs-20'>
              Access CDC APIs to provide consistent endpoints and quality delivery across the agency.
            </p>
            <p className='patua-one-regular fs-20'>
              Are you already an active data user? Visit the Self-Service Portal.
            </p>
          </div>
          
          <div className={`flex col ${mediumScreens ? 'm-gap' : 'center xl-gap sm-pad w-50p'}`}>
            <a className='usa-button w-100 btn-blue' href='/apis'>
              Explore APIs
            </a>
            <a className='usa-button w-100 btn-blue' href='/help/become-provider' target="_blank" rel="noopener noreferrer">
              Become an API Producer
            </a>
            <a className='usa-button w-100 btn-blue' href='/drs'>
              Visit Self-Service Portal
            </a>
          </div>
          
          {!mediumScreens && (
            <div className="sm-pad">
              <img className="maxh-mobile" src="/DGW_home-img.jpg" alt="man on computer" />
            </div>
          )}
        </div>
        
        <hr/>
        
        {/* API Section */}
        <div className={`container ${mediumScreens ? 'flex col sa ai-center' : ''}`}>
          <div className="flex ai-bsln m-gap">
            <h1 className='patua-one-regular'>Explore APIs</h1>
            <a href="/apis">View all</a>
          </div>
          
          <div className={`flex sa ${mediumScreens ? 'col l-gap' : 'xl-gap'}`}>
            <div className={mediumScreens ? "card-container-mobile" : "card-container"} onClick={() => handleOnClick('/docs/mvps-external-api/documentation')}>
              <h2 className="patua-one-regular fs-20">MVPS Reports External API</h2>
              <p className="patua-one-regular-not-bold">MVPS Reports API is an external API that provides a Line List and Errors and warnings data through the digital gateway.</p>
              <button className='usa-button w-100 btn-blue'>
                Learn More
              </button>
            </div>

            <div className={mediumScreens ? "card-container-mobile" : "card-container"} onClick={() => handleOnClick('/docs/nio-autocoder/purpose')}>
              <h2 className="patua-one-regular fs-20">NIO Autocoder</h2>
              <p className="patua-one-regular-not-bold">The NIO Autocoder enables any data collection platform to access powerful auto-coding capabilities for translating industry and occupation (I&O) text narratives into standardized I&O codes quickly and easily using a simple API call.</p>
              <button className='usa-button w-100 btn-blue'>
                Learn More
              </button>
            </div>

            <div className={mediumScreens ? "card-container-mobile" : "card-container"} onClick={() => handleOnClick('/docs/ews-person-api/documentation','internal')}>
              <h2 className="patua-one-regular fs-20">Enterprise Web Services (EWS) Person API</h2>
              <p className="patua-one-regular-not-bold">Retrieve up-to-date, non-sensitive information about a person.</p>
              <button className='usa-button w-100 btn-blue'>
                Learn More
              </button>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default Homepage
